import { BaseButton } from 'components'
import { usePageTitle, useProfileInfo } from 'hooks'
import BasePage from 'pages/base-page/base-page.page'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { routeService, stringService } from 'services'

import './booking-success.scss'

const BookingSuccess: React.FC = () => {
  const { t } = useTranslation()
  const titlePage = stringService.capitalizeFirstLetter(t('booking_success_title'))
  usePageTitle(titlePage!)
  const userInfo = useProfileInfo()
  const downloadLink = t('booking_download_link')
  return (
    <BasePage pageClass="edisu-page-booking-success">
      <div className="content ion-padding">
        {userInfo?.tipoProfilo === 'D' ? <h2>{t('booking_parent_success_title')}</h2> : <h2>{t('booking_success_title')}</h2>}
        {userInfo?.tipoProfilo === 'D' ? (
          <p>
            <Trans
              i18nKey="booking_parent_confirm_desc"
              components={[
                <a href={downloadLink} target="_blank" rel="noopener noreferrer" aria-label="Scarica il modulo in formato PDF">
                  LINK_PLACEHOLDER
                </a>,
              ]}
            />
          </p>
        ) : (
          <p>{t('booking_confirm_desc')}</p>
        )}

        <div className="links">
          <Link to={routeService.generateRoutePath('/')}>
            <BaseButton label={t('go_to_home')} />
          </Link>
        </div>
      </div>
    </BasePage>
  )
}

export default BookingSuccess
